import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "picture-viewer-bar" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "swiper-container" }
const _hoisted_4 = { class: "swiper-wrapper" }
const _hoisted_5 = { class: "swiper-slide" }
const _hoisted_6 = { class: "swiper-zoom-container" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-prev" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-next" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["picture-viewer-wrapper", [_ctx.isLeaving && 'leave']]),
    onWebkieAnimationend: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.destroy && _ctx.destroy(...args))),
    onAnimationend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.destroy && _ctx.destroy(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.imgLength > 1)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.curIndex + 1) + " / " + _toDisplayString(_ctx.imgLength), 1))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        class: _normalizeClass(["scale", [_ctx.isBig && 'big']]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scaleToggle && _ctx.scaleToggle(...args)))
      }, null, 2),
      _createElementVNode("span", {
        class: "close",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.picViewerData.list, (url) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: url,
                alt: ""
              }, null, 8, _hoisted_7)
            ])
          ]))
        }), 256))
      ]),
      _hoisted_8,
      _hoisted_9
    ])
  ], 34))
}